import React, { useState, useEffect } from 'react';
import { 
    Jumbotron, 
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink, 
    Container,
    Row,
    Col, 
    TabContent, 
    TabPane,
} from 'reactstrap';
import classnames from 'classnames';


const Media = () => {
    
    const [activeTab, setActiveTab] = useState('1');

    const toggle = tab => {
        if(activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
        <>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === '1'})}
                        onClick={() => { toggle('1') }}
                    >
                        Picture by @天蛙
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                     className={classnames({ active: activeTab === '2'})}
                     onClick={() => { toggle('2') }}
                    >
                        Music Shared
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab} id="mediaDiv">
                <TabPane tabId="1" >
                    <Row>
                        <Col>
                        <div>
                            <img src="/img/pic0729.jpg" id="TJPic" className="mt-2" alt="Picture by @天蛙"  />
                        </div>
                        </Col>
                    </Row>
                </TabPane>
                <TabPane tabId="2">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/S9gHS2iARxE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </TabPane>
            </TabContent>
        </>
    )
}

const Content = () => {
    return (
        <>
            <p><span class="float-right"><a href="https://mp.weixin.qq.com/s/4SxMKco8TrOs-ONMhUTzSg" class="badge badge-success">Follow us on WeChat</a></span></p><br />
            <h2>7月29日分享：怎麼能看見神的榮耀</h2>
            <p class="font-weight-light align-middle"><span class="badge badge-secondary text-wrap">Original</span> 天力  The WTL </p>
            <div id="contentDiv">
            <p className="text-primary">“耶穌説：’我不是對你說過，你若信，就必看見神的榮耀嗎？’” – 约翰福音11：40</p>

            <p>
            馬大和瑪麗亞一家和耶穌的關係非常好，她們對耶稣有信心。但她們的信心有時候也會打折扣，因為她們對耶穌的認識<span className="text-warning font-weight-bold">還不夠全面</span>。
            </p>
            <p>
            耶穌通過讓她們的兄弟拉撒路從死裡復活這件事來<span className="text-warning font-weight-bold">堅定</span>她們的信心。
            </p>
            <p>
            約翰福音記載著這麼一個小故事。有一天，拉撒路病得很重，快不行了。馬大、瑪麗亞姐妹倆慌忙找人去告訴耶穌，想讓耶穌趕緊過來给他醫病，讓她們的兄弟不要死。
            </p>
            <p>
            她們聽過、也見過耶穌行的神蹟，耶穌能醫病、趕鬼，能把水變成酒。所以她們的<span className="text-warning font-weight-bold">信心是</span>耶穌可以醫治病人，讓人不死。
            </p>
            <p>
            耶穌到的時候，<span className="text-warning font-weight-bold">拉撒路已经死了4天了</span>。馬大見到耶穌的第一句话就是：“主啊，你若早在這裡，我兄弟必不死。“ 這是她的信心。接著馬大又説：”就是現在，我也知道，你無論像神求什麼，神也必賜給你。” 
            </p>
            <p>
            這說明馬大相信耶穌可以做更大的事，但那更大的事是什麼，她自己也不是很清楚。耶穌回答馬大説：“你兄弟必然復活。” 耶穌是说我有能力现在讓拉撒路從死裡復活。
            </p>
            <p>
            但馬大對耶穌沒有這個信心，就説：“我知道在末日復活的时候，他必復活。” 潛台詞就是，神將來會讓人復活，但耶穌現在不能。
            </p>
            <p>
            耶穌就說：“復活在我，生命也在我。信我的人，雖然死了，也必復活；凡活著信我的人必永遠不死。<span className="text-warning font-weight-bold">你信這話嗎？”</span>
            </p>
            <p>
            耶穌說他就是復活，不僅將來可以讓死人復活，現在就可以讓死人復活。
            </p>
            <p>
            馬大說：“主啊，是的，我信你是基督，是神的兒子，就是那要臨到世界的。” 
            </p>
            <p>
            馬大説她信。<span className="text-warning font-weight-bold">她真的信了嗎？</span>
            </p>
            <p>
            當耶穌讓人把墓門打開的時候，馬大如果真的相信耶穌能讓拉撒路從死裡復活的話，會很積極快速的執行，但馬大用一句婉轉的話表達了她的不信。
            </p>
            <p>
            她説：“主啊，他现在必是臭了，因為他死了已經四天了。” 什麼意思？他的屍體都臭了，不可能復活了，主啊，就不必麻煩了。
            </p>
            <p>
            耶穌知道她的信心在哪，就略带責備的説：“我不是對你說過，你若信，就必看見神的榮耀嗎？” 耶穌的這句话話，不只是對馬大説的，也是對他的門徒説的。
            </p>
            <p>
            馬大他們見到了拉撒路的復活，信心也大大的增加。
            </p>
            <p>
            耶穌的這句話今天也是對我們説的。你的信心在哪裡呢？相信耶穌能幫助我們，改掉壞脾氣？幫助找工作？醫治疾病？更大的神蹟？
            </p>
            <p>
            <strong>願你有足夠的信心，能看見神的榮耀！</strong>
            </p>
            <p className="text-primary">
            這是我今天的禱告：“主啊，賜我更大的信心，看見你的榮耀！奉主耶穌的名禱告，阿們！”
            </p>

        </div>
        </>
    )
}

const MainSection = () => {
    return (
    <>
        <Container>
            <Row>
                <Col xs="12" sm="6" >
                    <Media />
                </Col>
                <Col xs="12" sm="6">
                    <Content />
                </Col>
            </Row>
        </Container>
    </>
    )
}

const Home = () => {

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    useEffect(() => {
        const picHeight = document.getElementById('TJPic').offsetHeight;

    })

    return (
        <>
            <Navbar color="dark" expand="md" className="sticky-top navbar-dark" id="navbar">
                <Container>
                    <NavbarBrand href="/" className="text-white">Chase Oaks Chinese Ministry</NavbarBrand>
                    <NavbarToggler onClick={toggle} />
                    <Collapse isOpen={isOpen} navbar>
                        <Nav className="mr-auto" navbar>
                            {/* <NavItem>
                                <NavLink href="/pastComponent" className="text-white">以前的分享</NavLink>
                            </NavItem> */}
                        </Nav>
                        <NavLink href="https://www.chaseoaks.org/chinese-ministry/" target="_blank" className="text-white">Chase Oaks Official</NavLink>
                    </Collapse>
                </Container>
            </Navbar>
            
            <Jumbotron id="jumbotron" fluid className="paral paralsec">
                <Container >
                    <h1 className="mx-auto text-black-40 shadow-lg p-3 rounded" id="todayShare">本日分享</h1>
                </Container>
            </Jumbotron>

            <MainSection />

            <div className="bg-light p-2 text-right font-weight-lighter">
                （封面图片来自网络 版权属于原作者）
            </div>
        </>
    )
}

export default Home;